<div class="preferences-wrapper">
  <div class="stars-bg"></div>
  <div class="stars-fg"></div>

  <!-- Sticky Top Bar with Back Button -->
  <div class="topbar card-glass">
    <button title="back" class="btn btn-outline-light" (click)="goBack()"><i class="bi bi-arrow-left"></i></button>
  </div>

  <div class="container mt-4 pt-5">
    <div class="card-glass preferences-card p-4">
      <div class="tab-buttons d-flex justify-content-center mb-4">
        <button
          [class.active]="selectedTab === 'liked'"
          (click)="selectedTab = 'liked'">
          💗 Liked
        </button>
        <button
          [class.active]="selectedTab === 'disliked'"
          (click)="selectedTab = 'disliked'">
          💔 Disliked
        </button>
      </div>

      <!-- Liked Users -->
      @if (selectedTab === 'liked') {
        <div>
          @if (likedUsers.length > 0) {
            <div>
              @for (user of likedUsers; track user) {
                <div class="user-card d-flex justify-content-between align-items-center">
                  <div>
                    <h6>{{ user.originalName }}</h6>
                    <small>{{ user.username }}</small>
                  </div>
                  <button class="btn btn-outline-light btn-sm" (click)="dislikeUser(user)">💔 Dislike</button>
                </div>
              }
            </div>
          } @else {
            <p class="text-center text-muted">You haven't liked anyone yet.</p>
          }
        </div>
      }

      <!-- Disliked Users -->
      @if (selectedTab === 'disliked') {
        <div>
          @if (dislikedUsers.length > 0) {
            <div>
              @for (user of dislikedUsers; track user) {
                <div class="user-card d-flex justify-content-between align-items-center">
                  <div>
                    <h6>{{ user.originalName }}</h6>
                    <small>{{ user.username }}</small>
                  </div>
                  <button class="btn btn-outline-success btn-sm" (click)="likeUser(user)">💗 Like</button>
                </div>
              }
            </div>
          } @else {
            <p class="text-center text-muted">You haven't disliked anyone yet 😇</p>
          }
        </div>
      }
    </div>
  </div>
</div>

<app-spinner [show]="spinner" [message]="spinMessage" />
